interface IServiceType {
    serviceTypeId: string;
    name: string;
    createDateUTC: Date;
    updateDateUTC: Date;
    requestedHours: number;
}

export class ServiceType {
    serviceTypeId: string;
    name: string;
    createDateUTC: Date;
    updateDateUTC: Date;
    requestedHours: number;

    constructor();
    constructor(object: IServiceType);
    constructor(object?: any)  {
        this.serviceTypeId = object && object.id || null;
        this.name = object && object.name || null;
        this.createDateUTC = object && object.createDateTime || null;
        this.updateDateUTC = object && object.updateDateTime || null;
        this.requestedHours = object && object.requestedHours || 0;
    }
}
